"use strict";

/**
 * Module EMAIL SERVICES
 */
angular.module("services")
	.factory("EmailService", ["$http", "SharedProperties", "ENV" , function ($http, SharedProperties, ENV) {

		var RESOURCE_NAME = "/email";

		/**
		 * API
		 */
		var API = {
			sendEmail: sendEmail
		};

		function sendEmail(modalEmail) {
			return $http(
				{
					url: ENV.API_URL + RESOURCE_NAME,
					method: "POST",
					data: $.param(modalEmail),
					headers: {"Content-Type": "application/x-www-form-urlencoded"}
				});
		}

		return API;


	}

	])
;


